import './style.scss'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FiMoreVertical, FiUserPlus } from 'react-icons/fi'
import utility from 'src/utils/utility'
import {
    Card, Button, Text, Flex, Box, tokens,
} from 'src/componentv2'
import { fontMedium, PAGE_PADDING_X } from 'src/model/v2/interface/constants'
import { TEAM_ROLE_LABELS, type CachedTeammate } from 'src/provider/API/v2/call-service/configuration'

const MOCK_TEAMMATES: CachedTeammate[] = [
    { id: 1, firstName: 'Olivia', lastName: 'Rhye', userName: 'olivia.rhye', email: 'olivia@firstnational.com', phone: '+234 801 234 5678', role: 'Admin', status: 'Active' },
    { id: 2, firstName: 'Phoenix', lastName: 'Baker', userName: 'phoenix.baker', email: 'phoenix@firstnational.com', phone: '+234 802 345 6789', role: 'ISA', status: 'Active' },
    { id: 3, firstName: 'Lana', lastName: 'Steiner', userName: 'lana.steiner', email: 'lana@firstnational.com', phone: '+234 803 456 7890', role: 'User', status: 'Invited' },
    { id: 4, firstName: 'Demi', lastName: 'Wilkinson', userName: 'demi.wilkinson', email: 'demi@firstnational.com', phone: '+234 804 567 8901', role: 'User', status: 'Active' },
]

const STATUS_STYLES: Record<string, { bg: string; color: string }> = {
    Active: { bg: '#ECFDF3', color: '#027A48' },
    Invited: { bg: '#FFFAEB', color: '#B54708' },
}

function getInitials(firstName: string, lastName: string) {
    return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase()
}

const TeamMembersPage = () => {
    const navigate = useNavigate()
    const [teammates] = useState<CachedTeammate[]>(MOCK_TEAMMATES)

    return (
        <div className="team-members-page" style={{ padding: `2.4rem ${PAGE_PADDING_X}` }}>
            <Flex justify="flex-end" topMargin="2">
                <Button variant="primary" size="md" icon={<FiUserPlus size={16} />} iconPosition="left">
                    Invite Teammate
                </Button>
            </Flex>

            <Card topMargin="1.6" padding="0" radius="1.2">
                <table className="team-members-table">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Username</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th aria-label="actions" />
                    </tr>
                    </thead>
                    <tbody>
                    {teammates.map((t) => {
                        const s = STATUS_STYLES[t.status] || STATUS_STYLES.Invited
                        return (
                            <tr key={t.id}>
                                <td>
                                    <Flex items="center" gap="1.2">
                                        <Box
                                            width="3.6" height="3.6" radius="999"
                                            bgColor={tokens.primarySoft}
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                                        >
                                            <Text fontSize="1.2" style={fontMedium} color={tokens.primaryDark}>
                                                {getInitials(t.firstName, t.lastName)}
                                            </Text>
                                        </Box>
                                        <Text fontSize="1.4" style={fontMedium} color={tokens.textDark}>
                                            {t.firstName} {t.lastName}
                                        </Text>
                                    </Flex>
                                </td>
                                <td>
                                    <Text fontSize="1.4" color={tokens.textMuted}>{t.userName}</Text>
                                </td>
                                <td>
                                    <Text fontSize="1.4" color={tokens.textMuted}>{t.email}</Text>
                                </td>
                                <td>
                                    <Text fontSize="1.4" color={tokens.textMuted}>{t.phone}</Text>
                                </td>
                                <td>
                                    <Text fontSize="1.4">{TEAM_ROLE_LABELS[t.role] ?? t.role}</Text>
                                </td>
                                <td>
                                        <span
                                            className="team-members-status-pill"
                                            style={{ background: s.bg, color: s.color }}
                                        >
                                            {t.status}
                                        </span>
                                </td>
                                <td className="team-members-table__action">
                                    <FiMoreVertical size={16} color={tokens.textMuted} />
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </Card>
        </div>
    )
}

export default utility.routeData('team-members', 'Team Members', <TeamMembersPage />)